import { LogisticAsyncTaskEntityType } from '../logistic-async-task.types';
import type { ReleaseCitySubdivisionSource } from '../../types/logistic-request-release-city.types';

export const LogisticRequestReleaseCitySubdivisionTask = {
  entityType: LogisticAsyncTaskEntityType.Request,
  type: 'calculateReleaseCitySubdivision',
  stages: {
    Calculate: 'calculate',
    DispatchWebhook: 'dispatchWebhook',
  },
} as const;

export type LogisticRequestCalculateReleaseCitySubdivisionPayload = {
  deliveryAddress: string | null;
  actualDeliveryAddress: string | null;
  deliveryAddressCity: string | null;
  deliveryAddressRegion: string | null;
  contractorCounterpartyId: number | null;
  releaseCitySubdivisionId: number | null;
  releaseCitySubdivisionSource: ReleaseCitySubdivisionSource | null;
};

export type LogisticRequestReleaseCitySubdivisionTaskDefinition = {
  entityType: typeof LogisticRequestReleaseCitySubdivisionTask.entityType;
  entityId: number;
  type: typeof LogisticRequestReleaseCitySubdivisionTask.type;
  stage: typeof LogisticRequestReleaseCitySubdivisionTask.stages.Calculate;
  payload: LogisticRequestCalculateReleaseCitySubdivisionPayload;
};

export const LogisticReservationReleaseCitySubdivisionTask = {
  entityType: LogisticAsyncTaskEntityType.Reservation,
  type: LogisticRequestReleaseCitySubdivisionTask.type,
  stages: { Calculate: 'calculate' },
} as const;

export type LogisticReservationReleaseCitySubdivisionTaskDefinition = {
  entityType: typeof LogisticReservationReleaseCitySubdivisionTask.entityType;
  entityId: number;
  type: typeof LogisticReservationReleaseCitySubdivisionTask.type;
  stage: typeof LogisticReservationReleaseCitySubdivisionTask.stages.Calculate;
  payload: Pick<
    LogisticRequestCalculateReleaseCitySubdivisionPayload,
    | 'deliveryAddress'
    | 'releaseCitySubdivisionId'
    | 'releaseCitySubdivisionSource'
  >;
};
